import React, { useState } from 'react';
import LabFiles from 'components/business/lab/LabFiles';

export const LabFilesCtx = React.createContext({});

function LabPageProvider(props) {
  const [ search, setSearch ] = useState('');
  const [ dataCSV, setDataCSV ] = useState(null);
  const ctx = {
    search,
    setSearch,
    dataCSV,
    setDataCSV,
  };
  return (
    <LabFilesCtx.Provider value={ ctx }>
      {props.children}
    </LabFilesCtx.Provider>
  );
}

function LabFilesPage() {
  return (
    <LabPageProvider>
      <LabFiles />
    </LabPageProvider>
  );
}

export default LabFilesPage;
